import { IInviteMemberPayload, ITeamMember, ITeamMemberApi, IUpdatePermissionsPayload, mapApiToTeamMember } from '@/@types/TeamMember';
import { api } from './api';

const BASE = '/v1/settings/team';

export const TeamService = {
  getMembers: async (): Promise<ITeamMember[]> => {
    const response = await api.get(BASE);
    const rawData: ITeamMemberApi[] = response.data?.data ?? response.data;
    return rawData.map(mapApiToTeamMember);
  },

  inviteMember: async (payload: IInviteMemberPayload): Promise<{ data: any; invite_url: string }> => {
    const response = await api.post(`${BASE}/invites`, {
      email: payload.email?.trim().toLowerCase(),
      name: payload.name || undefined,
      permissions: payload.permissions,
    });
    return {
      data: response.data?.data ?? response.data,
      invite_url: response.data?.invite_url ?? '',
    };
  },

  updatePermissions: async (
    memberId: string,
    payload: IUpdatePermissionsPayload,
  ): Promise<ITeamMember> => {
    const response = await api.put(`${BASE}/members/${memberId}`, {
      permissions: payload.permissions,
    });
    return response.data?.data ?? response.data;
  },

  resendInvite: async (inviteId: string): Promise<string> => {
    const response = await api.post(`${BASE}/invites/${inviteId}/resend`);
    return response.data?.invite_url ?? '';
  },

  cancelInvite: async (inviteId: string): Promise<void> => {
    await api.post(`${BASE}/invites/${inviteId}/cancel`);
  },

  revokeMember: async (accountUserId: string): Promise<void> => {
    await api.post(`${BASE}/members/${accountUserId}/revoke`);
  },
};
